import * as React from "react";

export const Feather = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7872 2.21323C15.1549 3.60815 15.4557 5.63215 14.2249 7.68351L10.6144 8.85962H13.2949C13.0214 9.16048 13.4043 8.77756 12.0367 10.1451L7.98853 11.4853H10.6691C8.64499 13.5094 5.3627 13.4273 3.94038 12.9897L2.13512 14.7949C1.8616 15.0684 1.45131 15.0684 1.20514 14.7949C0.931619 14.5487 0.931619 14.1384 1.20514 13.8923L8.28941 6.78091C8.45352 6.6168 8.45352 6.34329 8.28941 6.17918C8.1253 5.98772 7.85177 5.98772 7.66031 6.17918L2.79158 11.0477C2.60011 9.40664 2.87364 6.91767 4.54213 5.27659C5.19859 4.5928 4.7336 5.08513 6.86709 2.92437C9.35615 0.462744 12.064 0.517447 13.7872 2.21323Z"
    />
);
